import { Inject, Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import { Observable, delay, map, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom, from, switchMap } from 'rxjs';
import { DOCUMENT, Location } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';

export const VIDEOS = [
    { value: 1, name: 1 },
    { value: 2, name: 2 },
    { value: 3, name: 3 },
    { value: 4, name: 4 },
    { value: 5, name: 5 },
    { value: 6, name: 6 },
    { value: 7, name: 7 },
    { value: 8, name: 8 },
    { value: 9, name: 9 },
];

export const FORMATS = [
    { value: 'PDF', name: 'PDF' },
    { value: 'HTML', name: 'HTML' },
];

export interface SlugResponse {
    from: string;
    to: string;
}

@Injectable({
    providedIn: 'root',
})
export class MyService {
    private baseUrl: string = environment.baseUrl;
    private baseanotherUrl: string = environment.baseUrlOther;

    constructor(
        private meta: Meta,
        private titleService: Title,
        @Inject(DOCUMENT) private domDocument: Document,
        private location: Location,
        private authservice: AuthenticationService,
        private http: HttpClient,
        private activatedRoute: ActivatedRoute
    ) { }


    public capitalize(shorten: boolean, word: string): string {
        if (shorten)
            return word.charAt(0).toUpperCase() + word.slice(1);
        else
            return word.charAt(0).toUpperCase() + word.substring(1, word.length);
    }

    public getData(): string {
        return 'This is some data from MyService';
    }

    public detectLanguage(component: any, response: any, languages: any) {
        component.detectedLanguage = response.detectedLanguage;
        component.selectedOption = response.detectedLanguage;
        const source = component.selectedOption.toLowerCase();
        component.selectedOption = this.findMatchingLanguage(source, languages);
    }
    getAbsoluteUrl(): string {
        const protocol = window.location.protocol;
        const host = window.location.host;
        const path = this.location.path(); // Gets the path from the Angular router

        return `${protocol}//${host}${path}`;
    }
    public convertFromISOCode(isoCode: string): string {
        console.log("convert from iso code", isoCode);
        const isoToLanguageMap: { [key: string]: string } = {
            'af': 'Afrikaans',
            'sq': 'Albanian',
            'am': 'Amharic',
            'ar': 'Arabic',
            'hy': 'Armenian',
            'az': 'Azerbaijani',
            'eu': 'Basque',
            'be': 'Belarusian',
            'bn': 'Bengali',
            'bs': 'Bosnian',
            'bg': 'Bulgarian',
            'ca': 'Catalan',
            'ceb': 'Cebuano',
            'ny': 'Chichewa',
            'zh-CN': 'Chinese (Simplified)',
            'zh-TW': 'Chinese (Traditional)',
            'co': 'Corsican',
            'hr': 'Croatian',
            'cs': 'Czech',
            'da': 'Danish',
            'nl': 'Dutch',
            'en': 'English',
            'eo': 'Esperanto',
            'et': 'Estonian',
            'tl': 'Filipino',
            'fi': 'Finnish',
            'fr': 'French',
            'fy': 'Frisian',
            'gl': 'Galician',
            'ka': 'Georgian',
            'de': 'German',
            'el': 'Greek',
            'gu': 'Gujarati',
            'ht': 'Haitian Creole',
            'ha': 'Hausa',
            'haw': 'Hawaiian',
            'he': 'Hebrew',
            'hi-IN': 'Hindi',
            'hmn': 'Hmong',
            'hu': 'Hungarian',
            'is': 'Icelandic',
            'ig': 'Igbo',
            'id': 'Indonesian',
            'ga': 'Irish',
            'it': 'Italian',
            'ja': 'Japanese',
            'jv': 'Javanese',
            'kn': 'Kannada',
            'kk': 'Kazakh',
            'km': 'Khmer',
            'ko': 'Korean',
            'ku': 'Kurdish (Kurmanji)',
            'ky': 'Kyrgyz',
            'lo': 'Lao',
            'la': 'Latin',
            'lv': 'Latvian',
            'lt': 'Lithuanian',
            'lb': 'Luxembourgish',
            'mk': 'Macedonian',
            'mg': 'Malagasy',
            'ms': 'Malay',
            'ml': 'Malayalam',
            'mt': 'Maltese',
            'mi': 'Maori',
            'mr': 'Marathi',
            'mn': 'Mongolian',
            'my': 'Myanmar (Burmese)',
            'ne': 'Nepali',
            'no': 'Norwegian',
            'or': 'Odia',
            'ps': 'Pashto',
            'fa': 'Persian',
            'pl': 'Polish',
            'pt': 'Portuguese',
            'pa': 'Punjabi',
            'ro': 'Romanian',
            'ru': 'Russian',
            'sm': 'Samoan',
            'gd': 'Scots Gaelic',
            'sr': 'Serbian',
            'st': 'Sesotho',
            'sn': 'Shona',
            'sd': 'Sindhi',
            'si': 'Sinhala',
            'sk': 'Slovak',
            'sl': 'Slovenian',
            'so': 'Somali',
            'es': 'Spanish',
            'su': 'Sundanese',
            'sw': 'Swahili',
            'sv': 'Swedish',
            'tg': 'Tajik',
            'ta': 'Tamil',
            'te': 'Telugu',
            'th': 'Thai',
            'tr': 'Turkish',
            'uk': 'Ukrainian',
            'ur': 'Urdu',
            'uz': 'Uzbek',
            'vi': 'Vietnamese',
            'cy': 'Welsh',
            'xh': 'Xhosa',
            'yi': 'Yiddish',
            'yo': 'Yoruba',
            'zu': 'Zulu'
        };

        return isoToLanguageMap[isoCode] || isoCode;
    }
    public initializeComponent(component: any, languages: any): void {
        console.log("in the intialize", languages)
        const lowerCaseSlugFrom = component.selectedOption.toLowerCase();
        console.log("slug from", lowerCaseSlugFrom)

        if (component.TargetLanguage && component.TargetLanguage.toLowerCase() !== '') {
            console.log("inside slug target language")
            const lowerCaseSlugTo = component.TargetLanguage.toLowerCase();
            console.log("slug to", lowerCaseSlugTo)
            const matchedLanguage1 = this.findMatchingLanguage(lowerCaseSlugTo, languages);
            console.log("slug", matchedLanguage1)
            if (matchedLanguage1) {
                component.TargetLanguage = matchedLanguage1;
                console.log("slug", component.TargetLanguage)
            } else {
                console.log("No matching language found");
            }
            ;
        }


        const matchedLanguage = this.findMatchingLanguage(lowerCaseSlugFrom, languages);
        console.log("slug", matchedLanguage)

        if (matchedLanguage) {
            component.selectedOption = matchedLanguage;
            console.log("slug", component.selectedOption)
        } else {
            console.log("No matching language found.");
        }
    }

    public findMatchingLanguage(lowerCaseSlug: string, languages: any): string | undefined {
        const matchingKey = Object.keys(languages).find(key => {
            const firstWordLang = languages[key].split(' ')[0].toLowerCase();
            return firstWordLang.includes(lowerCaseSlug);
        });
        return matchingKey ? languages[matchingKey] : undefined;
    }


    // Example method to make HTTP request
    public fetchData(): Observable<any> {
        return this.http.get<any>('https://dummyjson.com/products');
    }


    parseSlugParams(slug: string): SlugResponse {
        const slugResponse: SlugResponse = { from: '', to: '' };

        if (!slug) return slugResponse;

        const splittedSlug = slug.split('-');

        slugResponse.from = this.toTitleCase(splittedSlug[0]);
        slugResponse.to = this.toTitleCase(splittedSlug[2]);
        console.log('SLUG', slugResponse);
        return slugResponse;
    }

    toTitleCase(text: string): string {
        if (text && text != '' && text.length >= 1) {
            text = text.toLowerCase();
            return text.charAt(0).toUpperCase() + text.slice(1);
        }
        return '';
    }
    getExistingToken(): Observable<any> {
        return from(this.getToken()).pipe(
            switchMap((token) => {
                const headers = {
                    Authorization: 'Bearer ' + token
                };
                return this.http.get(`${this.baseanotherUrl}/apiToken`, { headers });
            })
        );
    }

    deleteExistingToken(): Observable<any> {
        return from(this.getToken()).pipe(
            switchMap((token) => {
                const headers = {
                    Authorization: 'Bearer ' + token
                };
                return this.http.delete(`${this.baseanotherUrl}/apiToken`, { headers });
            })
        );
    }

    createNewToken(): Observable<any> {
        const email = this.authservice.gettUserName();
        console.log("getting token for username " + email);
        const requestBody = {
            email
        };

        return from(this.getToken()).pipe(
            switchMap((token) => {
                const headers = {
                    Authorization: 'Bearer ' + token
                };
                return this.http.post(`${this.baseanotherUrl}/apiToken`, requestBody, { headers });
            })
        );
    }

    translate(
        text: any,
        from: string,
        to: string,
        member: string
    ): Observable<any> {
        const data = new FormData();
        data.append('text', text);
        data.append('from', from);
        data.append('to', to);
        data.append('userID', member);

        const headers = {
            Authorization: 'Bearer ' + this.getToken(),
        };
        return this.http.post(`${this.baseUrl}/inbound/translate`, data, {
            headers: headers,
        });
    }

    translateTextToSpeech(
        text: string,
        from: string,
        member: string,
        gender: string
    ): Observable<any> {
        const data = new URLSearchParams();
        data.append('text', text);
        data.append('from', from);
        data.append('userID', member);
        data.append('malefemale', gender);

        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: 'Bearer ' + this.getToken(),
        };
        return this.http.post(`${this.baseUrl}/inbound/tts`, data.toString(), {
            headers: headers,
        });
    }

    async getToken() {
        console.log('getting token');
        try {
            const data = await this.authservice.getToken();
            return data;
        } catch (error) {
            throw error;
        }
    }

    convertBase64ToBlob(base64: any) {
        let raw = window.atob(base64);
        let rawLength = raw.length;
        let arr = new Uint8Array(new ArrayBuffer(rawLength));

        for (let i = 0; i < rawLength; i++) {
            arr[i] = raw.charCodeAt(i);
        }
        let blob = new Blob([arr], {
            type: 'audio/webm',
        });
        return blob;
    }
    convertBlobToBase64 = (blob: Blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = reject;
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.readAsDataURL(blob);
        });

    xlit(text: any, from: string, member: string): Observable<any> {
        const data = new FormData();
        data.append('text', text);
        data.append('lang', from);
        data.append('userID', member);

        const headers = {
            Authorization: 'Bearer ' + this.getToken(),
        };
        return this.http.post(`${this.baseUrl}/inbound/transliterate`, data, {
            headers: headers,
        });
    }

    bytesToSize(bytes: any) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return 'n/a';
        var i = parseInt(
            Math.floor(Math.log(bytes) / Math.log(1024)).toString(),
            10
        );
        if (i == 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    }

    invoiceProcess(
        base64: string,
        userID: string,
        json: string,
        fileName: string,
        base64Template: string,
        fileNameTemplate: string
    ): Observable<any> {
        const data = new URLSearchParams();
        data.append('data', base64);
        data.append('templateData', base64Template);
        data.append('userID', userID);
        data.append('json', json);
        data.append('fileName', fileName);
        data.append('fileNameTemplate', fileNameTemplate);

        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: 'Bearer ' + this.getToken(),
        };

        return this.http.post(
            `${this.baseanotherUrl}/extractData`,
            data.toString(),
            { headers: headers }
        );
    }
    getNotifications(displayAll: boolean, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        let url = `${this.baseanotherUrl}/notification`;
        if (displayAll) {
            url += '?displayAll=true';
        }
        return this.http.get(url, { headers: headers });
    }

    deleteNotification(notificationId: string, token: any) {
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        const url = `${this.baseanotherUrl}/notification`;

        return this.http.delete(url, {
            headers,
            params: { notificationId },
        });
    }

    patchNotification(notificationId: string, token: any) {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.patch(
            `${this.baseanotherUrl}/notification`,
            { notificationId },
            { headers: headers }
        );
    }

    getLanguageList(token: any): Observable<any> {
        const endpoint = `${this.baseanotherUrl}/localeList`;
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http.get(endpoint, { headers: headers });
    }

    getTtsList(
        persona: string,
        style: string,
        language: string,
        gender: string,
        voiceType: string,
        token: any
    ): Observable<any> {
        const endpoint = `${this.baseanotherUrl}/ttsList`;
        const params = new URLSearchParams({
            persona,
            style,
            language,
            gender,
            voiceType
        });

        const headers = {
            Authorization: 'Bearer ' + token,
        };

        const url = `${endpoint}?${params.toString()}`;
        const audioPath = 'https://app.genailia.com/assets/ttsvoices/';

        return this.http.get<any>(url, { headers }).pipe(
            map((response) => {
                // Ensure the response has the 'voices' array
                if (!response || !Array.isArray(response.voices)) {
                    throw new Error('Response does not contain voices array');
                }

                return response.voices.map((item: any) => ({
                    ...item,
                    sample_voice_url: `${audioPath}${item.sampleVoiceFilename}`,
                    playing: false,
                }));
            })
        );
    }


    checkUserJavaSideAsync(token: any, json: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(`${this.baseanotherUrl}/checkUser`, json, {
            headers: headers,
        });
    }

    async checkUserJavaSide(token: any, json: any): Promise<any> {
        const observable = this.checkUserJavaSideAsync(token, json);
        return await firstValueFrom(observable);
    }

    tts(
        voiceId: any,
        text: any,
        voiceSpeed: any,
        styleDegree: any,
        amplifyFactor: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            voiceId,
            text,
            voiceSpeed,
            styleDegree,
            amplifyFactor,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(`${this.baseanotherUrl}/tts`, requestBody, {
            headers: headers,
        });
    }

    texttranslate(
        sourceLanguage: any,
        targetLanguage: any,
        text: any,
        performTts: any,
        performTransliterate: any,
        performTransliterateSource: any,
        translationModel: any,
        transliterationModel: any,
        voiceSpeed: any,
        styleDegree: any,
        amplifyFactor: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            sourceLanguage,
            targetLanguage,
            text,
            performTts,
            performTransliterate,
            performTransliterateSource,
            translationModel,
            transliterationModel,
            voiceSpeed,
            styleDegree,
            amplifyFactor,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(`${this.baseanotherUrl}/translate`, requestBody, {
            headers: headers,
        });
    }

    voiceClone(
        inputLang: any,
        gender: any,
        sharedVoice: any,
        voiceCloneModel: any,
        personaName: any,
        data: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            inputLang,
            gender,
            sharedVoice,
            voiceCloneModel,
            personaName,
            data,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(`${this.baseanotherUrl}/cloneVoice`, requestBody, {
            headers: headers,
        });
    }

    transliterate(
        text: any,
        sourceLanguage: any,
        targetLanguage: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            text,
            sourceLanguage,
            targetLanguage,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(`${this.baseanotherUrl}/transliterate`, requestBody, {
            headers: headers,
        });
    }

    detection(text: any, token: any): Observable<any> {
        const requestBody = {
            text,

        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(
            `${this.baseanotherUrl}/detectLanguage`,
            requestBody,
            { headers: headers }
        );
    }
    voiceDetection(data: any, token: any): Observable<any> {
        const requestBody = {
            data,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(
            `${this.baseanotherUrl}/detectLanguage`,
            requestBody,
            { headers: headers }
        );
    }

    transcription(
        sample: any,
        includeTimestamp: any,
        performTranslate: any,
        performTransliterateSource: any,
        voiceSpeed: any,
        performTts: any,
        performTransliterate: any,
        speakerIdentification: any,
        numberOfSpeakers: any,
        sampleStartSecond: any,
        sampleEndSecond: any,
        sourceLanguage: any,
        targetLanguage: any,
        transliterationModel: any,
        languageDetectionModel: any,
        transcriptionModel: any,
        translationModel: any,
        data: any,
        operation: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            sample,
            operation,
            includeTimestamp,
            performTranslate,
            performTransliterateSource,
            voiceSpeed,
            performTts,
            performTransliterate,
            speakerIdentification,
            numberOfSpeakers,
            sampleStartSecond,
            sampleEndSecond,
            sourceLanguage,
            targetLanguage,
            transliterationModel,
            languageDetectionModel,
            transcriptionModel,
            translationModel,
            data,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(`${this.baseanotherUrl}/transcribe`, requestBody, {
            headers: headers,
        });
    }

    documentTranslation(
        sourceLanguage: any,
        targetLanguage: any,
        fileName: any,
        outputFileName: any,
        fileType: any,
        outputFormat: any,
        languageDetectionModel: any,
        translationModel: any,
        documentFormatModel: any,
        data: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            sourceLanguage,
            targetLanguage,
            fileName,
            outputFileName,
            fileType,
            outputFormat,
            languageDetectionModel,
            translationModel,
            documentFormatModel,
            data,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(
            `${this.baseanotherUrl}/documentTranslate`,
            requestBody,
            { headers: headers }
        );
    }

    getFilesDownload(jobId: boolean, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        const url = `${this.baseanotherUrl}/jobStatus?jobId=${jobId}`;

        return this.http.get(url, { headers: headers });
    }
    downloadBase64File(base64Data: string, fileName: string) {
        const fileType = this.getFileMimeType(fileName);
        const blob = this.base64ToBlob(base64Data, fileType);
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        anchor.click();
        window.URL.revokeObjectURL(url);
    }
    public base64ToBlob(base64Data: string, contentType: string): Blob {
        // Clean up the base64 string
        const cleanedBase64Data = base64Data.replace(/(\r\n|\n|\r)/gm, '').trim();
        try {
            const byteCharacters = atob(cleanedBase64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: contentType });
        } catch (error) {
            console.error('Failed to convert base64 to blob', error);
            throw error;
        }
    }
    getFileMimeType(fileName: string): string {
        const extension = fileName.split('.').pop()?.toLowerCase();
        const mimeTypes: { [key: string]: string } = {
            pdf: 'application/pdf',
            mp3: 'audio/mpeg',
            mp4: 'video/mp4',
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            gif: 'image/gif',
            doc: 'application/msword',
            docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            xls: 'application/vnd.ms-excel',
            xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ppt: 'application/vnd.ms-powerpoint',
            pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            txt: 'text/plain',
            html: 'text/html',
            css: 'text/css',
            js: 'application/javascript',
            json: 'application/json',
            xml: 'application/xml',
        };

        return mimeTypes[extension || ''] || 'application/octet-stream';
    }
    ocr(
        sourceLanguage: any,
        targetLanguage: any,
        performTranslation: any,
        fileName: any,
        ocrModel: any,
        translationModel: any,
        data: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            sourceLanguage,
            targetLanguage,
            performTranslation,
            fileName,
            ocrModel,
            translationModel,
            data,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(`${this.baseanotherUrl}/ocr`, requestBody, {
            headers: headers,
        });
    }

    extractData(
        pdfData: any,
        templateData: any,
        pdfFileName: any,
        templateFileName: any,
        modelName: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            pdfData,
            templateData,
            pdfFileName,
            templateFileName,
            modelName,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(`${this.baseanotherUrl}/extractData`, requestBody, {
            headers: headers,
        });
    }

    audioTranscription(
        sample: any,
        includeTimestamp: any,
        performTranslate: any,
        operation: any,
        performTts: any,
        sourceLanguage: any,
        targetLanguage: any,
        data: any,
        languageDetectionModel: any,
        transcriptionModel: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            sample,
            includeTimestamp,
            performTranslate,
            operation,
            performTts,
            data,
            sourceLanguage,
            targetLanguage,
            languageDetectionModel,
            transcriptionModel,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(`${this.baseanotherUrl}/transcribe`, requestBody, {
            headers: headers,
        });
    }

    youtubeMatching(
        keywords: any,
        numVideos: any,
        timespan: any,
        sortOrder: any,
        youtubeAPIModel: any,
        token: any
    ): Observable<any> {
        const requestBody = {
            keywords,
            numVideos,
            timespan,
            sortOrder,
            youtubeAPIModel,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(
            `${this.baseanotherUrl}/ytMatchingVideos`,
            requestBody,
            { headers: headers }
        );
    }

    stitchAVTranslate(
        sample: any,
        sampleStartSecond: any,
        sampleEndSecond: any,
        voiceSpeed: any,
        voiceId: any,
        audioOutputOnly: any,
        sourceLanguage: any,
        targetLanguage: any,
        englishSourceOrTarget: any,
        keepBackground: any,
        lipSync: any,
        transcriptInSourceLanguage: any,
        transcriptInTargetLanguage: any,
        transcriptInEnglishLanguage: any,
        data: any,
        token: any,
        operation: any
    ): Observable<any> {
        const requestBody = {
            sample,
            sampleStartSecond,
            sampleEndSecond,
            voiceSpeed,
            voiceId,
            audioOutputOnly,
            sourceLanguage,
            targetLanguage,
            englishSourceOrTarget,
            keepBackground,
            lipSync,
            transcriptInSourceLanguage,
            transcriptInTargetLanguage,
            transcriptInEnglishLanguage,
            data, operation
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(
            `${this.baseanotherUrl}/stitchAVTranslate`,
            requestBody,
            { headers: headers }
        );
    }



    usage(token: any): Observable<any> {


        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.get(
            `${this.baseanotherUrl}/usage`,
            { headers: headers }
        );
    }



    transaction(month: any, year: any, token: any): Observable<any> {
        const data = new FormData();
        data.append('month', month);
        data.append('year', year);

        let params = new HttpParams();
        data.forEach((value, key) => {
            params = params.append(key, value as string);
        });

        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.get(
            `${this.baseanotherUrl}/usage/transactions`,

            { params, headers: headers }
        );
    }

    modelList(token: any): Observable<any> {


        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.get(
            `${this.baseanotherUrl}/modelList`,

            { headers: headers }

        );
    }


    setTitleAndMeta(
        title: string,
        description: string,
        keywords: string,
        canonicalUrlEndingMatch: string
    ) {
        const canonicalUrl = this.getAbsoluteUrl();
        if (canonicalUrlEndingMatch != "NA" && canonicalUrlEndingMatch != "" && !canonicalUrl.toLowerCase().endsWith(canonicalUrlEndingMatch.toLowerCase())) {
            return;
        }

        title = this.title + " - " + title;
        description = this.description + " - " + description;
        keywords = this.keywords + ", " + keywords;

        this.titleService.setTitle(title);

        this.updateOrAddMetaTag('description', description);
        this.updateOrAddMetaTag('keywords', keywords);

        this.updateOrAddMetaTag('og:title', title, 'property');
        this.updateOrAddMetaTag('og:description', description, 'property');
        this.updateOrAddMetaTag('og:url', canonicalUrl, 'property');
        this.updateOrAddMetaTag('og:site_name', canonicalUrl, 'Genailia');

        this.updateOrAddMetaTag('twitter:title', title);
        this.updateOrAddMetaTag('twitter:site', "@genailia");
        this.updateOrAddMetaTag('twitter:description', description);
        this.updateOrAddMetaTag('twitter:url', canonicalUrl);
        this.updateOrAddMetaTag('twitter:card', "summary");

        this.setCanonicalURL(canonicalUrl);
        this.addJSONLD(canonicalUrl, title, description, "Genailia - GenZ Technologies", "https://www.genailia.com/", "https://www.genailia.com/assets/images/logo1.webp");
    }

    private addJSONLD(
        pageUrl: string,
        pageName: string,
        pageDescription: string,
        organizationName: string,
        organizationUrl: string,
        logoUrl: string
    ): void {
        const script = this.domDocument.createElement('script');
        script.type = 'application/ld+json';
        script.text = `
    {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "${pageUrl}",
          "url": "${pageUrl}",
          "name": "${pageName}",
          "isPartOf": {
            "@id": "${organizationUrl}#website"
          },
          "datePublished": "2023-07-31T21:32:46+00:00",
          "dateModified": "2024-08-31T22:36:41+00:00",
          "description": "${pageDescription}",
          "breadcrumb": {
            "@id": "${pageUrl}#breadcrumb"
          },
          "inLanguage": "en-US",
          "potentialAction": [
            {
              "@type": "ReadAction",
              "target": [
                "${pageUrl}"
              ]
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "@id": "${pageUrl}#breadcrumb",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "${organizationUrl}"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog"
            }
          ]
        },
        {
          "@type": "WebSite",
          "@id": "${organizationUrl}#website",
          "url": "${organizationUrl}",
          "name": "${organizationName}",
          "description": "Redefining your customer and employee experience.",
          "publisher": {
            "@id": "${organizationUrl}#organization"
          },
          "potentialAction": [
            {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": "${organizationUrl}?s={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            }
          ],
          "inLanguage": "en-US"
        },
        {
          "@type": "Organization",
          "@id": "${organizationUrl}#organization",
          "name": "${organizationName}",
          "url": "${organizationUrl}",
          "logo": {
            "@type": "ImageObject",
            "inLanguage": "en-US",
            "@id": "${organizationUrl}#/schema/logo/image/",
            "url": "${logoUrl}",
            "contentUrl": "${logoUrl}",
            "width": 244,
            "height": 70,
            "caption": "${organizationName}"
          },
          "image": {
            "@id": "${organizationUrl}#/schema/logo/image/"
          },
          "sameAs": [
            "https://www.facebook.com/genzersdotai",
            "https://www.instagram.com/genzers.ai",
            "https://x.com/genailia",
            "https://youtube.com/@genailia",
            "https://www.linkedin.com/company/genailia/"
          ]
        }
      ]
    }
  `;
        this.domDocument.head.appendChild(script);
    }


    private updateOrAddMetaTag(name: string, content: string, attrName: string = 'name') {
        const existingTag = this.meta.getTag(`${attrName}="${name}"`);
        if (existingTag) {
            this.meta.removeTag(`${attrName}="${name}"`);
        }
        this.meta.addTag({ [attrName]: name, content });
    }

    private setCanonicalURL(url: string) {
        const head = this.domDocument.getElementsByTagName('head')[0];
        let existingLink: HTMLLinkElement | null = head.querySelector('link[rel="canonical"]');

        if (existingLink) {
            existingLink.href = url;
        } else {
            const link: HTMLLinkElement = this.domDocument.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', url);
            head.appendChild(link);
        }


        this.meta.addTag({
            rel: 'canonical',
            href: url,
        });
    }


    title = "Genailia - Gen AI, Linguistic AI & Accelerators";
    description = "AI/ML Models - Translation,Social Media Insights,LLM,GPT,Chatbots,Transcription,TTS,SST,ASR,Xlit";
    keywords = "translation, transcription, transliteration, languages, chatbots, GPT, NLP, LLM, AI, Social Media Insights, ML, Other Language Typing, AI Model deployments, TTS, Speech to Text, Text to Speech, ASR";


}

